// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"ba49f380","160":"1c715e8b","208":"6f21008e","293":"da9086d3","516":"82247ea3","519":"6e10d29d","917":"23417f81","946":"83a0ccab"}[chunkId] + ".chunk.js";
};